import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { useMsal } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { loginRequest } from "../util/authConfig";
import Footer from "../components/Footer";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: #000000;
  color: white;
  text-align: center;
`;

const Button = styled.button`
  background-color: red;
  color: white;
  padding: 10px 20px;
  margin-top: 20px;
  border: none;
  cursor: pointer;
  font-size: 16px;
  width: 200px;
  border-radius: 3px;
`;

const DisclaimerText = styled.p`
  font-size: 14px;
  color: #ccc;
  text-align: center;
  margin-top: 20px;
  max-width: 400px;
`;

const Login: React.FC = () => {
  const navigate = useNavigate();
  const { instance } = useMsal();

  const handleLogin = async () => {
    try {
      const loginResponse = await instance.loginPopup(loginRequest);
      sessionStorage.setItem("accessToken", loginResponse.accessToken);
      navigate("/calculator-selection");
    } catch (error) {
      console.error("Login failed:", error);
    }
  };

  return (
    <Container>
      <img alt="WSP Logo" style={{ width: 200 }} src="/wsplogo.png" />
      <h1>Health & Safety</h1>
      <Button onClick={handleLogin}>Sign in with Microsoft</Button>
      <DisclaimerText>
        Access is limited to authorised individuals only. Do not share your credentials.
      </DisclaimerText>
      <Footer />
    </Container>
  );
};

export default Login;